export const exchangeColor:{[key: string]: string} = {
  upbit: '#376FE0',
  cobit: '#4C7AA2',
  bithumb: '#FF8435',
  default: 'white',
}